import { render, staticRenderFns } from "./CustomPageAppLegacy.vue?vue&type=template&id=1c170f6a"
import script from "./CustomPageAppLegacy.vue?vue&type=script&lang=ts"
export * from "./CustomPageAppLegacy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports